import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '@fantaz/shared/app-config';
import {
  CurrentUser,
  UserListRequest,
  UserListResponse,
  WalletModel,
} from '@fantaz/shared/data-access/models';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) {}

  getCurrentUser(): Observable<CurrentUser | null> {
    const endpoint = `${environment.apiBaseUrl}/core-client/api/user/currentUser`;
    return this.http.get<CurrentUser>(endpoint);
  }

  getWallet(): Observable<WalletModel | null> {
    const endpoint = `${environment.apiBaseUrl}/core-client/api/wallet-status`;
    return this.http.get<WalletModel>(endpoint);
  }
}
